export default __webpack_public_path__ + "static/media/storageUnit1-afterB-1024w.45344dc0.webp";